import Vue from 'vue'
import App from './App.vue'

import '@babel/polyfill'

import router from './router'

import store from './store'

import '@/assets/css/base.css'
import '@/assets/css/theme.css'
import '@/assets/font/iconfont.css'

import '@/assets/js/base'

// axios
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = '/hall/flowhall-service/'
// axios.defaults.baseURL = 'http://172.20.10.119:8100'

// axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
// axios.defaults.headers['Access-Control-Allow-Credentials'] = true
// axios.defaults.headers['Access-Control-Allow-Origin'] = 'http://hall.ncvt.net:8100/'
Vue.use(VueAxios, axios)

// qs
import qs from 'qs';
Vue.prototype.$qs = qs;

// 自定义拖拽排序组件
import Vddl from 'vddl';
Vue.use(Vddl)

// 图片预览功能
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    title: false
  }
})

// echart
import VCharts from 'v-charts'
Vue.use(VCharts)

// element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, { size: 'small' })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')